module.exports = __webpack_public_path__ + "img/Z61Q_04.8b3266d8.jpg";